export default __webpack_public_path__ + "static/media/logogesco.b2c34a30.png";